import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getLocalDelegateReference2ls94nvl5ojb2 as getLocalDelegateReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { nullElementzitp7se36veh as nullElement } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_instancegwok6qx7et5m as Companion_instance,
  FormSelector1zdq40oqbcvms as FormSelector,
  FormRendererv0cfjgipxuxv as FormRenderer,
  Companion_instance17v8p6g2424o4 as Companion_instance_0,
  ViewRenderer1i6kznnbg7y21 as ViewRenderer,
  get_kind27kjvyfnc9an8 as get_kind,
  get_type3f1sl153qhh1c as get_type,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  priority7vn90mx06311 as priority,
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
} from './FormRenderer.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { default308h22k6ofhww as default_0 } from '../../../../../lightning-server-shared/com/lightningkite/serialization/Defaults.mjs';
import { get_padded3m3frjnjujncx as get_padded } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_atTopStart2sqdmdfleu6ji as get_atTopStart,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  reactive2pl1t9wy5gll5 as reactive,
  reactiveScope1fcalsbdr0hgb as reactiveScope,
} from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function form$lambda($innerSelector$delegate) {
  // Inline function 'kotlin.getValue' call
  getLocalDelegateReference('innerSelector', KProperty0(), false);
  return $innerSelector$delegate.f2();
}
function form$lambda_0($inner$delegate) {
  // Inline function 'kotlin.getValue' call
  getLocalDelegateReference('inner', KProperty0(), false);
  return $inner$delegate.f2();
}
function view$lambda($innerSelector$delegate) {
  // Inline function 'kotlin.getValue' call
  getLocalDelegateReference('innerSelector', KProperty0(), false);
  return $innerSelector$delegate.f2();
}
function view$lambda_0($inner$delegate) {
  // Inline function 'kotlin.getValue' call
  getLocalDelegateReference('inner', KProperty0(), false);
  return $inner$delegate.f2();
}
function NullableFormRenderer$form$lambda$lambda(v) {
  return !(v == null);
}
var NullableFormRendererClass;
function NullableFormRenderer() {
  if (NullableFormRendererClass === VOID) {
    class $ {
      i20() {
        return 'Null Wrapper';
      }
      edu() {
        return 0.4;
      }
      rdu() {
        return true;
      }
      fdu(module_0, selector) {
        return selector.gdu_1.az().l11();
      }
      kdu(module_0, selector) {
        var tmp = ensureNotNull(nullElement(selector.gdu_1));
        var innerSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        var innerSelector = selector.copyChangingType(innerSerializer);
        var inner = module_0.adu(innerSelector);
        return inner.p1().lds(inner.p1().hds_1 + 3.0);
      }
      ndu(module_0, selector) {
        var tmp = ensureNotNull(nullElement(selector.gdu_1));
        var innerSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        var innerSelector$delegate = lazy(() => selector.copyChangingType(innerSerializer));
        var inner$delegate = lazy(() => module_0.adu(form$lambda(innerSelector$delegate)));
        var tmp_0 = Companion_instance;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.odu(module_0, this, tmp_1, VOID, VOID, ($this$FormRenderer, field, mutable) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$FormRenderer.pc());
          var tmp0_elvis_lhs = $this$FormRenderer.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
          $this$FormRenderer.gbb(p, view);
          view.zbm(false);
          var tmp0_elvis_lhs_0 = ReactiveState__getOrNull_impl_1asnfp(mutable.sah());
          var ifNotNull = {_v: tmp0_elvis_lhs_0 == null ? default_0(innerSerializer) : tmp0_elvis_lhs_0};
          var tmp = get_padded(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.stack' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Frame())(view.pc());
          var tmp0_elvis_lhs_1 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.gbb(p_0, view_0);
          var tmp_0 = get_atTopStart(view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (Checkbox())(view_0.pc());
          var tmp0_elvis_lhs_2 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
          view_0.gbb(p_1, view_1);
          var tmp_1 = NullableFormRenderer$form$lambda$lambda;
          view_1.zah(view_1.ebk_1, mutable.dak(tmp_1, (e, v) => v ? ifNotNull._v : null));
          view_0.hbb(p_1, view_1);
          view_0.lbb(tmp_0, view_1);
          view.hbb(p_0, view_0);
          view.lbb(tmp, view_0);
          var tmp_2 = get_expanding(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.stack' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Frame())(view.pc());
          var tmp0_elvis_lhs_3 = view.ebb_1;
          var p_2 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
          view.gbb(p_2, view_2);
          var $this$stack = view_2;
          var isNull = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(mutable) == null);
          reactive($this$stack, ($this$reactive) => {
            $this$stack.bba();
            var tmp;
            if (!$this$reactive.daj(isNull)) {
              var tmp_0 = form$lambda_0(inner$delegate).vds();
              var tmp_1 = (v) => v == null ? default_0(innerSerializer) : v;
              tmp_0($this$stack, field, mutable.dak(tmp_1, (e, v) => {
                ifNotNull._v = v;
                return e == null ? null : v;
              }));
              tmp = Unit_instance;
            }
            return Unit_instance;
          });
          view.hbb(p_2, view_2);
          view.lbb(tmp_2, view_2);
          $this$FormRenderer.hbb(p, view);
          return view;
        });
        return isInterface(tmp_2, FormRenderer()) ? tmp_2 : THROW_CCE();
      }
      pdu(module_0, selector) {
        var tmp = ensureNotNull(nullElement(selector.gdu_1));
        var innerSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        var innerSelector$delegate = lazy(() => selector.copyChangingType(innerSerializer));
        var inner$delegate = lazy(() => module_0.bdu(view$lambda(innerSelector$delegate)));
        var tmp_0 = Companion_instance_0;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.qdu(module_0, this, tmp_1, VOID, VOID, ($this$ViewRenderer, field, readable) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.stack' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Frame())($this$ViewRenderer.pc());
          var tmp0_elvis_lhs = $this$ViewRenderer.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
          $this$ViewRenderer.gbb(p, view);
          var $this$stack = view;
          var isNull = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(readable) == null);
          reactiveScope($this$stack, ($this$reactiveScope) => {
            $this$stack.bba();
            if ($this$reactiveScope.daj(isNull)) {
              text($this$stack, 'N/A');
            } else {
              var tmp = view$lambda_0(inner$delegate).vds();
              tmp($this$stack, field, lens(readable, (it) => it == null ? default_0(innerSerializer) : it));
            }
            return Unit_instance;
          });
          $this$ViewRenderer.hbb(p, view);
          return view;
        });
        return isInterface(tmp_2, ViewRenderer()) ? tmp_2 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).h94 = get_type;
    protoOf($).sdu = get_annotation;
    protoOf($).wds = get_handlesField;
    protoOf($).tdu = priority;
    initMetadataForObject($, 'NullableFormRenderer', VOID, VOID, [Generator(), Generator_0()]);
    NullableFormRendererClass = $;
  }
  return NullableFormRendererClass;
}
var NullableFormRenderer_instance;
function NullableFormRenderer_getInstance() {
  return NullableFormRenderer_instance;
}
//region block: init
NullableFormRenderer_instance = new (NullableFormRenderer())();
//endregion
//region block: exports
export {
  NullableFormRenderer_instance as NullableFormRenderer_instance2fo3dccdjw01o,
};
//endregion

//# sourceMappingURL=NullableFormRenderer.mjs.map
